__turbopack_context__.v({
  "imageContainer": "_XIflq_imageContainer",
  "magicSymbol": "_XIflq_magicSymbol",
  "noWrap": "_XIflq_noWrap",
});
